// Herkunftsmarker der Landung: `?entry=web` haengt `resolveAppRedirect`
// (google-oauth-handler/app-redirect.ts) an BEIDE Rueckkehr-Ziele. Er erreicht
// den Browser nur auf dem `returnLink`-Pfad, also genau bei der Uebergabe von
// der Marketing-Seite an die App. Damit bleibt der Web-Trichter von einer
// In-App-Verbindung unterscheidbar, auch wenn GA4 die Sitzung am
// Supabase-Ruecksprung (`…supabase.co/auth/v1/verify`) zerschneidet.
//
// Bewusst ein EIGENES Modul und keine Erweiterung von `lib/flowIntent.ts`,
// obwohl das Muster (URL lesen, Marker ablegen, Parameter per replaceState
// entfernen) von dort stammt: `getFlowIntent() === 'feedcheck'` steuert
// `notify_feed_check` und damit die Report-Mail-Kette. Dieser Marker hier ist
// rein analytisch und darf nie in diese Wirkung hineinreichen.
//
// sessionStorage statt localStorage: der Marker beschreibt EINE Landung, nicht
// den Nutzer. Ein zweiter Tab, der die App direkt aufruft, ist eine
// In-App-Sitzung und soll auch so gezaehlt werden.
const ENTRY_KEY = 'feed-optimizer-entry';

export type EntryMarker = 'web' | 'app';

export function captureEntryMarker(): void {
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get('entry') !== 'web') return;
    try {
      sessionStorage.setItem(ENTRY_KEY, 'web');
    } catch {
      // Kein sessionStorage (Privatmodus, gesperrte Speicher): der Marker geht
      // verloren, `readEntryMarker` liefert dann 'app'. Der Parameter wird
      // trotzdem entfernt, damit die URL sauber bleibt. Ein spaeterer Lauf
      // koennte ihn ohnehin nicht ablegen.
    }
    url.searchParams.delete('entry');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  } catch {
    // Analytics darf nie einen Nutzerpfad brechen (gleiche Haltung wie
    // AuthContext.pushUserPropertiesWithInternalFlag).
  }
}

export function readEntryMarker(): EntryMarker {
  try {
    return sessionStorage.getItem(ENTRY_KEY) === 'web' ? 'web' : 'app';
  } catch {
    // Ohne lesbaren Speicher gilt die Landung als In-App. 'app' ist der
    // konservative Wert: er behauptet keinen Web-Trichter, den niemand belegen
    // kann.
    return 'app';
  }
}
